//@flow
import { CONFIRMATION_MESSAGE } from "./constants"

export const confirmDeletePath = (id: string): Object => ({
  pathname: `/admin/users/${id}/confirm/delete`,
  state: {
    modal: true,
    successPath: "/admin/users/",
    message: CONFIRMATION_MESSAGE
  }
})



// WEBPACK FOOTER //
// ./src/Users/helpers.js